// Generated by scripts/translate-catalog.mjs from scripts/translate-catalog.config.json.
// Do not edit: add a language to the config and re-run the script.
import 'moment/dist/locale/de';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/es';
import 'moment/dist/locale/it';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/ro';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/nl';
import 'moment/dist/locale/da';
import 'moment/dist/locale/fi';

export const LANGUAGE_CODES = ['de', 'en', 'fr', 'es', 'it', 'pt', 'ro', 'pl', 'nl', 'da', 'fi'];
export const LANGUAGE_NAMES = {
  de: 'Deutsch',
  en: 'English',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  ro: 'Română',
  pl: 'Polski',
  nl: 'Nederlands',
  da: 'Dansk',
  fi: 'Suomi',
};
export const MOMENT_LOCALES = {
  de: 'de',
  en: 'en-gb',
  fr: 'fr',
  es: 'es',
  it: 'it',
  pt: 'pt',
  ro: 'ro',
  pl: 'pl',
  nl: 'nl',
  da: 'da',
  fi: 'fi',
};
